import React from 'react';
import classNames from 'classnames';
import ProjectSalesCardTable from './ProjectedSalesCardTable';

export default function ProjectSalesCard({
  products,
  locales,
  editMode,
  backgroundCard,
  className,
  titleColor,
  titleStyle,
}) {
  return (
    <div
      className={classNames('bmc-page-fincard-content relative', className)}
      style={{ background: backgroundCard }}
    >
      <div
        className={`bmc-page-fincard-title ${titleStyle} custom-font-title`}
        style={{ color: titleColor }}
      >
        {locales.costRevenue.projectedSales.header}
      </div>

      <ProjectSalesCardTable
        collection={products}
        tabs={locales.costRevenue.projectedSales.tabs}
        isReadOnly={!editMode}
      />
    </div>
  );
}
